import { get, post } from "../../axios-interceptor-setup/apiService";

const BASE_URL = "auth";

export const searchUserApis = ( body ) => {
    let apiUrl= 'search-users'
    return post(`${BASE_URL}/${apiUrl}`,body);
}
